class CheckoutForm extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.checkoutCartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.checkoutCartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch(`?sections=${this.sectionId}`)
      .then((response) => response.json())
      .then((responseJson) => {
        const html = new DOMParser().parseFromString(responseJson[`${this.sectionId}`], 'text/html');
        const selector = '.checkout-form__products-info';
        const targetElement = this.querySelector(selector);
        const sourceElement = html.querySelector(selector);

        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      })
      .catch((e) => {
        console.error(e);
      });
    })
  }

  disconnectedCallback() {
    if (this.checkoutCartUpdateUnsubscriber) {
      this.checkoutCartUpdateUnsubscriber();
    }
  }
}

customElements.define('checkout-form', CheckoutForm);